














































































































































































import Vue from "vue";
import Component from "vue-class-component";

import {
  FactFindPolicyDto,
  CreatePensionCommand,
  OwnerDto,
  PensionTypeDto,
  PensionStatusDto,
  ProductProviderDto,
  PaymentFrequencyDto,
  UpdatePensionCommand,
  ClientSelector,
  PolicyFundDto,
  PolicyStatusDto,
  PolicyRoleDto
} from "@/api/ClientPortalApiClient";

import ApiFactory from "../../api/ApiFactory";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxPensionType from "@/views/lookups/CbxPensionType.vue";
import CbxPolicyStatus from "@/views/lookups/CbxPolicyStatus.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import CbxCountry from "@/views/lookups/CbxCountry.vue";
import CbxPaymentFrequency from "@/views/lookups/CbxPaymentFrequency.vue";
import CbxCounty from "@/views/lookups/CbxCounty.vue";
import { config } from "@vue/test-utils";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "../../filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxPensionType,
    CbxPolicyStatus,
    CbxProductProvider,
    CbxPaymentFrequency
  }
})
export default class FactFindPensions extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private pensions: FactFindPolicyDto[] = [];
  private emptyPension = new FactFindPolicyDto();
  private displayModel = new FactFindPolicyDto();
  private selectPension = new FactFindPolicyDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private modelSig = "";

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.loadPensions(true);
  }

  $refs!: {
    owner: CbxOwner;
    pensionType: CbxPensionType;
    pensionStatus: CbxPolicyStatus;
    productProvider: CbxProductProvider;
    paymentFrequency: CbxPaymentFrequency;
    mainForm: HTMLFormElement;
  };

  private savePension(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Pension...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreatePensionCommand();

    cmd.contactId = this.contactId;
    cmd.policyOwner = this.displayModel.policyOwner || ClientSelector.Main;
    cmd.policyNo = this.displayModel.policyNo;
    cmd.premium = this.displayModel.premium;
    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);
    cmd.maturityDate = FormatDate.forApi(this.displayModel.maturityDate);
    cmd.description = this.displayModel.description;
    cmd.nra = this.displayModel.nra || 0;

    if (this.displayModel.status) {
      cmd.statusId = this.displayModel.status.id;
    }
    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }
    if (this.displayModel.paymentFrequency) {
      cmd.paymentFrequencyId = this.displayModel.paymentFrequency.id;
    }

    try {
      const result = await api.factFindPension_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadPensions();
      this.displayModel =
        this.pensions.find(x => x.id === result) || this.displayModel;

      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Pension saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Pension. Please try again."
      );
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Pension...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdatePensionCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.policyOwner = this.displayModel.policyOwner;
    cmd.policyNo = this.displayModel.policyNo;
    cmd.premium = this.displayModel.premium;
    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);
    cmd.maturityDate = FormatDate.forApi(
      this.displayModel.maturityDate || "01/01/1900"
    );
    cmd.description = this.displayModel.description;
    cmd.nra = this.displayModel.nra || 0;

    if (this.displayModel.status) {
      cmd.statusId = this.displayModel.status.id;
    }
    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }
    if (this.displayModel.paymentFrequency) {
      cmd.paymentFrequencyId = this.displayModel.paymentFrequency.id;
    }

    try {
      var result = await api.factFindPension_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Pension updated successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not save Pension. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Pension. Please try again."
      );
    }

    return false;
  }

  private async loadPensions(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Pensions...");
    const api = ApiFactory.CreateDataClient();

    try {
      const result = await api.factFindPension_IndexAll(this.contactId);
      this.pensions = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.pensions = [];
      LoadingSpinnerService.Failure(
        "Could not load Pensions. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindPolicyDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.displayModel.inceptionDate = FormatDate.forInput(item.inceptionDate);
    this.displayModel.maturityDate = FormatDate.forInput(item.maturityDate);
    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();

    if (this.displayModel.policyOwner) {
      this.$refs.owner.setSelected(this.displayModel.policyOwner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.pensionType.setSelectedName(this.displayModel.description || "");
    this.$refs.pensionStatus.setSelected(this.displayModel.status);

    if (this.displayModel.provider) {
      this.$refs.productProvider.setSelected(this.displayModel.provider);
    } else {
      this.$refs.productProvider.setSelected(new ProductProviderDto());
    }

    this.$refs.paymentFrequency.setSelected(this.displayModel.paymentFrequency);
  }

  private clearData() {
    this.emptyPension = new FactFindPolicyDto();
    this.displayModel = this.emptyPension;

    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.pensionType.setSelected(new PensionTypeDto());
    this.$refs.pensionStatus.setSelected(new PensionStatusDto());
    this.$refs.productProvider.setSelected(new ProductProviderDto());
    this.$refs.paymentFrequency.setSelected(new PaymentFrequencyDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyPension.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.policyOwner = owner;
  }
  private pensionTypeSelected(pensionType: PensionTypeDto) {
    this.displayModel.description = pensionType.name;
  }
  private pensionStatusSelected(pensionStatus: PolicyStatusDto) {
    this.displayModel.status = pensionStatus;
  }
  private productProviderSelected(productProvider: ProductProviderDto) {
    this.displayModel.provider = productProvider;
  }
  private paymentFrequencySelected(paymentFrequency: PaymentFrequencyDto) {
    this.displayModel.paymentFrequency = paymentFrequency;
  }
}
